import { getCurrentInstance, AppContext } from 'vue';

/**
 * 可忽略的错误，不需要任何提示
 */
export class IgnoreError extends Error {
  data: any;

  constructor(message?: string, data?: any) {
    super(message);
    this.data = data;
  }
}

/**
 * 弹出警告msgbox
 */
export class AlertError extends Error {
  title: string;
  warning: boolean;
  code: number; // 错误码
  data: any;
  ctx?: AppContext;

  constructor(
    message: string,
    { title = '', warning = false, code = -1, data = undefined as any } = {}
  ) {
    super(message);
    this.title = title;
    this.warning = warning;
    this.code = code || -1;
    this.data = data;

    this.ctx = getCurrentInstance()?.appContext;
  }
}

/**
 * 弹出Notification
 */
export class TipError extends Error {
  title: string;
  warning: boolean;
  code: number; // 错误码
  data: any;
  ctx?: AppContext;

  constructor(
    message: string,
    { title = '', warning = false, code = -1, data = undefined as any } = {}
  ) {
    super(message);
    this.title = title;
    this.warning = warning;
    this.code = code || -1;
    this.data = data;

    this.ctx = getCurrentInstance()?.appContext;
  }
}
